import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import { TextFastStyleConfigs } from './fast-style-config';
import { transaction } from '@src/slide/domain/slide-app';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import TextFastStyleCard from '@src/framework/workbench/common/components/selectable-panel/text-fast-style-card';
import Styles from './index.less';
import { PcEditLogicService } from '@src/slide/content-viewer/service/canvas-renderer/entry/pc-edit/logic/pc-edit-logic-service';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { ITextRunStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import { isShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { FillTypeToModelMap } from '@src/framework/workbench/drawer/ui/text/fill/config';

// Panel中展示的个数
const PANEL_COL_NUM = 7;

const TEXT_EFFECT = ['shadow', 'glow', 'reflection'];

@Feature()
export class TextFastStyleFeature extends BaseSelectablePanelFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public getContent() {
        return <div className={Styles['shape-fast-style']}>
            <SelectablePanel
                colNumber={PANEL_COL_NUM}
                showArrow={true}
                expandHeight={260}
                childrenElements={
                    [
                        {
                            cardList: TextFastStyleConfigs.map((item, index) => ({
                                element: <TextFastStyleCard
                                    text={item.title}
                                    key={index}
                                    onClick={this.handleCardClick}
                                    textStyle={item.style}
                                    slideModel={
                                        this.getAppService().viewableServiceLayer.selectionService.currentSlide!
                                    }
                                    editorServices={this.getEditorServices()}
                                />,
                                id: String(index),
                            })),
                        },
                    ]
                } />
        </div>;
    }

    public shouldDisabled() {
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        return !models.filter(isShapeModel).length;
    }

    private getEditorServices() {
        return {
            uiDataService: this.getUiDataService(),
            logicService: new PcEditLogicService(),
        };
    }

    private handleCardClick = (textRunStyle: ITextRunStyle) => {
        let fillStyle = {};
        // 先将所有文本填充相关的属性置为空
        Object.values(FillTypeToModelMap).forEach((p) => {
            fillStyle[p] = undefined;
        });
        fillStyle = {
            ...fillStyle,
            ...textRunStyle,
        };
        let effectStyle = {};
        TEXT_EFFECT.forEach((p) => {
            effectStyle[p] = null;
        });
        effectStyle = {
            ...effectStyle,
            ...textRunStyle.effect,
        };
        transaction(() => {
            this.getToolbarMenu()?.callback('', ActionType.FONT_FILL, fillStyle, { onlyChangeUI: false, onlyPreview: false });
            this.getToolbarMenu()?.callback('', ActionType.FONT_BORDER, { border: textRunStyle.border }, { onlyChangeUI: false, onlyPreview: false });
            this.getToolbarMenu()?.callback('', ActionType.FONT_EFFECT, { effect: effectStyle }, { onlyChangeUI: false, onlyPreview: false });
        });
    };
}
